import React from 'react';
import { ReactTitle } from 'react-meta-tags';
import ReportsComponent from '../../shared/reports';
import MainTemplate from '../mainTemplate';

const Reports = () => {

  return <MainTemplate>
    <ReactTitle title={`Reportes - Reverse Factoring`} />
    <ReportsComponent />
  </MainTemplate>;
};

export default Reports;